import { push } from 'react-router-redux';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import repAPI from '../../sources/api/repAPI';

// constants
import { CURRENT_REP_UPDATE } from '../../constants/currentRepTypes';

// lib
import handleServerValidation from '../../lib/handleServerValidation';
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { DATA_EDIT_ERROR, DATA_EDIT_SUCCESS } from '../../constants/messages';

export function* currentRepUpdate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params      = action.payload || {};
  const phoneNumber = params.phoneNumber;

  if (phoneNumber) {
    params.phoneNumber = `+1${phoneNumber.replace(/\D+/g, '')}`;
  }

  try {
    yield *httpSaga(CURRENT_REP_UPDATE, call(repAPI.updateSelf, params));
    yield toastr.success('Success', DATA_EDIT_SUCCESS);
    yield put(push('/reps/books'));
  } catch (err) {
    const errors = handleServerValidation('rep', err.response.body.details, { nestedPath: 'user' });

    yield toastr.error(DATA_EDIT_ERROR);
    yield put(error(CURRENT_REP_UPDATE, errors));
  } finally {
    yield put(doneIndicator(CURRENT_REP_UPDATE));
  }
}

export function* watchCurrentRepUpdate() {
  yield takeEvery(CURRENT_REP_UPDATE, currentRepUpdate);
}

export default function* root() {
  yield all([
    fork(watchCurrentRepUpdate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/rep/currentRepUpdate.js